<template>
    <div id="logviews">
        <div>
            <v-breadcrumbs :items="breadcrumbs">
                <v-icon slot="divider">forward</v-icon>
            </v-breadcrumbs>
        </div>
        <v-container fluid fill-height>
            <v-row align-center justify-center>
                <v-col xs12>
                    <base-material-card color="primary" icon="library_books" title="Monitor de Consulta RECE"
                        class="elevation-1 px-5 py-3">
                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <!-- <exportar-excel v-tippy style="cursor: pointer" :data="datafiltered"
                                :exportFields="logviews.camposexcel" name="LogViews.xlsx">
                                <v-btn x-small fab dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel> -->
                        </v-card-actions>

                        <v-card-text>
                            <div id="filtros">
                                <v-card>
                                    <v-card-title>
                                        <v-card class="primary darken-2 white--text titulomodal">
                                            <v-icon class="white--text">search</v-icon>&nbsp;
                                            <span class="subheading">
                                                <strong>Filtros de Búsqueda</strong>
                                            </span>
                                        </v-card>
                                        <v-spacer></v-spacer>
                                        &nbsp;
                                    </v-card-title><br />
                                    <v-form ref="form" lazy-validation>
                                        <v-card-text>
                                            <v-container grid-list-md text-xs-center @keyup.enter="buscar()">
                                                <v-row wrap>
                                                    <v-col xs="12" sm="3" md="3" lg="3">
                                                        <v-menu offset-x ref="menu1" :close-on-content-click="false"
                                                            v-model="menu1" :nudge-right="40"
                                                            transition="scale-transition" offset-y max-width="290px"
                                                            min-width="290px">
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field v-on="on" v-model="model.fecha_ini"
                                                                    label="Fecha Inicial" prepend-icon="event" @blur="
                                                                        model.fecha_ini = parseDate(model.fecha_ini)
                                                                        " v-mask="'####-##-##'"
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="model.fecha_ini" no-title
                                                                @input="menu1 = false" locale="es-mx"></v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col xs="12" sm="3" md="3" lg="3">
                                                        <v-menu offset-x ref="menu2" :close-on-content-click="false"
                                                            v-model="menu2" :nudge-right="40"
                                                            transition="scale-transition" offset-y max-width="290px"
                                                            min-width="290px">
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field v-on="on" v-model="model.fecha_fin"
                                                                    label="Fecha Final" prepend-icon="event" @blur="
                                                                        model.fecha_fin = parseDate(model.fecha_fin)
                                                                        " v-mask="'####-##-##'"
                                                                    :rules="[rules.required]"></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="model.fecha_fin" no-title
                                                                @input="menu2 = false" locale="es-mx"></v-date-picker>
                                                        </v-menu>
                                                    </v-col>
                                                    <v-col xs="12" sm="3" md="3" lg="3">
                                                        <v-autocomplete v-model="usuarioSelected" :items="usuarios"
                                                            :hide-no-data="true" :hide-selected="true"
                                                            item-text="text" item-value="id"
                                                            label="Selecciona un Usuario">
                                                        </v-autocomplete>
                                                    </v-col>
                                                    <!-- <v-col xs="12" sm="3" md="3" lg="3">
                                                        <v-text-field v-model="model.rfc" label="RFC"></v-text-field>
                                                    </v-col> -->
                                                </v-row>
                                            </v-container>
                                        </v-card-text>
                                    </v-form>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="success" :loading="loading" @click.native="buscar()">
                                            <v-icon>search</v-icon> Buscar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </div>
                            <br />
                            <p></p>
                            <v-tabs grow style="margin-bottom: 30px;">
                                <v-tabs-slider color="primary"></v-tabs-slider>
                                <v-tab key="logviews">Log de Acceso a Consultas</v-tab>
                                <v-tab key="reportes">Log de Generación Reportes RECE</v-tab>

                                <v-tab-item key="logviews">
                                    <div id="datagrid">

                                        <v-client-table ref="vuetable" :data="logviews.items" :columns="columns"
                                            :options="options" class="elevation-2 pa-2">
                                            <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info">No se encontró ningun
                                                    registro</v-alert>
                                            </template>

                                            <template slot="fecha" slot-scope="props">
                                                {{ props.row.fecha.substring(0, 16).replace("T", " ") }}
                                            </template>

                                            <!-- <template slot="view" slot-scope="props">
                                                {{ titulos.filter(item => item.url == props.row.view)[0].nombre }}
                                            </template> -->
                                        </v-client-table>
                                    </div>
                                </v-tab-item>
                                <v-tab-item key="reportes">
                                    <div id="datagrid_reportes">

                                        <v-client-table ref="vuetable" :data="reportes" :columns="columns_reportes"
                                            :options="options_reportes" class="elevation-2 pa-2">
                                            <template slot="noResults">
                                                <v-alert :value="true" icon="info" color="info">No se encontró ningun
                                                    registro</v-alert>
                                            </template>

                                            <template slot="fecha_solicitud" slot-scope="props">
                                                {{ props.row.fecha_solicitud.substring(0, 10) }}
                                            </template>

                                            <template slot="fecha_generacion" slot-scope="props">
                                                {{ props.row.fecha_generacion.substring(0, 10) }}
                                            </template>

                                            <template slot="criterio" slot-scope="props">
                                                {{ getCriterio(props.row.criterio) }}
                                            </template>
                                        </v-client-table>
                                    </div>
                                </v-tab-item>
                            </v-tabs>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    components: {},
    data: () => ({
        reportes: [],
        columns_reportes: ["usuario_email", "nombre_reporte", "criterio", "fecha_solicitud", "fecha_generacion"],
        options_reportes: {
            filterable: ["usuario_email", "nombre_reporte", "fecha_solicitud", "fecha_generacion"],
            sortable: ["usuario_email", "nombre_reporte", "fecha_solicitud", "fecha_generacion"],

            headings: {
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                fecha_solicitud: "Solicitado",
                fecha_generacion: "Generado",
                criterio: "Criterio de Búsqueda",
            },
        },
        fab: false,
        name: "datagrid",
        columns: ["view", "email", "fecha"],
        show_loading: true,
        options: {
            filterable: ["view", "email", "fecha"],
            sortable: ["view", "email", "fecha"],

            headings: {
                view: "Vista Pantalla",
                email: "Usuario",
                fecha: "Fecha"
            },
        },
        URL: "",
        filtros: 0,
        menu1: false,
        menu2: false,
        show_loading: true,
        breadcrumbs: [{
            text: "Inicio",
            disabled: false,
            to: "/home"
        },
        {
            text: "Datos Generales",
            disabled: true,
            to: ""
        },
        {
            text: "Monitor de Consulta",
            disabled: true,
            to: ""
        }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            modelo: "",
            usuario: "",
            fecha_ini: "",
            fecha_fin: "",
            accion: ""
        },
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        usuarios: [],
        usuarioSelected: "",
        modeloSelected: "",
        accionSelected: "",
        informacionModal: "",
        logviews: {
            camposexcel: {
                View: "view",
                RFC: "rfc",
                Usuario: "email",
                Fecha: {
                    field: "fecha",
                    callback: function (value) {
                        return moment(String(value)).format("YYYY-MM-DD");
                    }
                },
            },

            items: []
        }
    }),

    filters: {
        prettyJSON: function (value) {
            try {
                if (value) return JSON.stringify(JSON.parse(value), null, 4);
            } catch (error) {
                if (value) return value;
            }
        }
    },
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.logviews.items;
            }

        },
    },
    methods: {
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        buscar: async function () {
            if (!this.$refs.form.validate()) {
                return
            }

            var datos = {
                fecha_de: this.model.fecha_ini,
                fecha_a: this.model.fecha_fin,
                rfc: this.$local_storage.get("rfc")
            }

            if (this.usuarioSelected != null && this.usuarioSelected != "") {
                datos['usuario'] = this.usuarioSelected
            }

            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            await axios
                .post(this.$hostname + "vucem/get_logs_views/", datos)
                .then(async res => {
                    if (typeof res.data != "undefined") {
                        this.logviews.items = res.data;
                        for (var k in this.logviews.items) {
                            let view_name = this.titulos.filter(item => item.url == this.logviews.items[k].view);

                            if (view_name.length > 0) {
                                this.logviews.items[k].view = view_name[0].nombre;
                            }
                        }
                        await this.getReportes()
                    } else {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "Error",
                            text: "Error inesperado, verifica los datos de entrada"
                            //showConfirmButton: false,
                        });
                    }
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "Error",
                        text: "Error inesperado, verifica los datos de entrada"
                        //showConfirmButton: false,
                    });
                    console.log(error);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        get_titulos: function () {
            axios.post(this.$hostname + "configuracion/etips/get_titulos/")
                .then(response => {
                    this.titulos = response.data;
                    this.$root.$dialogLoader.hide();
                }).catch(error => {
                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "Error",
                        text: "Error inesperado al cargar los titulos"
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        getReportes: async function () {
            let data = {
                rfc: this.$local_storage.get("rfc"),
                fecha_de: this.model.fecha_ini,
                fecha_a: this.model.fecha_fin
            }

            axios.post(this.$apiSA31 + "soluciona24/reportes/get_logs_reportes/", data)
                .then(response => {
                    if (response.data != undefined) {
                        if (this.usuarioSelected != null && this.usuarioSelected != "") {
                            this.reportes = response.data.filter(item => item.estatus == 2 && item.usuario == this.usuarioSelected);
                        } else {
                            this.reportes = response.data.filter(item => item.estatus == 2);
                        }
                    }
                }).catch(error => {
                    this.$swal({
                        position: "center",
                        type: "error",
                        title: "Error",
                        text: "Error inesperado al cargar los reportes"
                    });
                });
        },
        getCriterio: function(criterio) {
            console.log(criterio)
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    if(params.lista != undefined && params.lista != "") {
                        return "Por Listado de Pedimentos";
                    } else if (params.fecha_de != undefined){
                        return params.tipo_fecha.toString().toUpperCase()+"  De: " + params.fecha_de + ", " + " A: " + params.fecha_a;
                    } else {
                        console.log("en este na")
                        return "N/A";
                    }
                } else {
                    console.log("aca en este")
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        getUsuarios: function () {            
            let data = {                
                sistema: this.$sistema,
                filtros: {"cliente__identificador": this.$local_storage.get("rfc"), "perfil_id": 66},
            };

            axios
                .post(this.$hostname + "usuarios/getall_usuarios_clientes/", data)                
                .then(response => {         
                    this.usuarios = response.data.results.map(item =>( {"id": item.id, "text": item.email}));
                })
                .catch(error => {
                    console.log(error)
                    this.usuarios = []
                });
        },
    }, //methods
    created: function () {
        this.URL = this.$hostname + "log_sistema/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.getUsuarios()
        this.get_titulos()
    }
};
</script>
<style scoped>
.elevation-1>>>.vl {
    border-left: 1px solid gray;
    height: auto;
}

.elevation-1>>>.v-label.theme--light {
    color: black !important;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control {
    margin-bottom: -35px;
}

.elevation-1>>>.v-input--has-state>div:nth-child(1)>div:nth-child(2) {
    margin-top: -10px;
}

.elevation-1>>>div.v-input.theme--light.v-input--selection-controls.v-input--checkbox div.v-input__control div.v-input__slot label.v-label.theme--light {
    font-size: 10px !important;
}

.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted;
}

.showPerfil6 {
    cursor: pointer;
    border-bottom: 1px dotted;
    color: red;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}
</style>
